import { Component } from '@angular/core';

@Component({
  selector: 'bp-breadcrumb',
  exportAs: 'bpBreadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BpBreadcrumbComponent {
}
